import { useMemo, type ReactNode } from 'react';
import {
  CollectionProvider,
  type CollectionConfig,
} from '@ygoargentina/ui/components/collection/collection-context';
import { useUserStore } from '@/store/users';
import { useAuthQuery } from '@/hooks/use-auth-query';
import { useCards } from '@/hooks/use-cards';
import { axiosConfig } from '@/services/request';

const cardHref = (konamiId: number) => `/cards/${konamiId}`;

// La colección (y sus diálogos, que también usan cajas y "Mis ventas") vive en
// `@ygoargentina/ui`; esto le pasa lo de folder: usuario, catálogo de cartas,
// headers y el `useAuthQuery` que manda al login ante un 401.
export default function FolderCollectionProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { user } = useUserStore();

  const value = useMemo<CollectionConfig>(
    () => ({
      user,
      useCardCatalog: useCards,
      useQuery: useAuthQuery,
      requestConfig: axiosConfig,
      cardHref,
      sellerSettingsHref: '/users/me/seller',
    }),
    [user]
  );

  return <CollectionProvider value={value}>{children}</CollectionProvider>;
}
